module.exports = __webpack_public_path__ + "static/45gde-704292b1cd2b2fae7514795d8bd35e3b.gif";